// Referral attribution capture (SMRTSTATS-351).
//
// A referral link is https://football.smrtstats.com/?ref=CODE — it lands on
// the marketing page first, so we stash the code in localStorage and read it
// back when the player finally reaches /player/register (which can be several
// navigations later). Sending it on register attributes the new account to
// the referrer; the backend silently ignores unknown/self codes.

const REF_KEY = 'referral_code';

// Codes are 8 chars from an unambiguous A-Z2-9 alphabet (see backend
// ReferralService). Sanitise hard so a junk query param can't poison signup.
const sanitize = (raw) =>
  String(raw || '')
    .toUpperCase()
    .replace(/[^A-Z0-9]/g, '')
    .slice(0, 12);

// Read ?ref= from a query string and persist it. Idempotent: a navigation
// without ?ref leaves any previously stored code untouched.
export const captureReferralFromUrl = (search) => {
  const qs = search ?? (typeof window !== 'undefined' ? window.location.search : '');
  if (!qs) return null;
  let code = '';
  try {
    code = sanitize(new URLSearchParams(qs).get('ref'));
  } catch {
    return null;
  }
  if (!code) return null;
  try {
    localStorage.setItem(REF_KEY, code);
  } catch {
    /* storage disabled — ignore */
  }
  return code;
};

export const getStoredReferral = () => {
  try {
    return sanitize(localStorage.getItem(REF_KEY)) || null;
  } catch {
    return null;
  }
};

export const clearStoredReferral = () => {
  try {
    localStorage.removeItem(REF_KEY);
  } catch {
    /* ignore */
  }
};
